/* @flow */

/* eslint-disable camelcase */
import * as React from 'react';
// $FlowFixMe
import styled, { withTheme, createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';

// $FlowFixMe
import { Tooltip } from '@bijie/react-bnb';
import Icon from '../Icon';
import {
  setMarginModeTrue as setMarginModeTrueAction,
  setMarginModeFalse as setMarginModeFalseAction,
  setMarginAccountMaxBorrowable as setMarginAccountMaxBorrowableAction,
  fetchMaxBorrowAmount,
} from '../../actions/actionsSet/margin';
import { getLabel } from '../../utils/i18n';
import withI18n from '../../utils/withI18n';

const BalanceBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
  color: ${({ theme }) => theme.fontColor};
  .iconfont {
    vertical-align: middle;
  }
`;

const Content = styled.div`
  padding: 3px;
`;

const TipContent = styled.div`
  max-width: 250px;
  border-radius:5px;
  `;

const IconTipWrapper = styled.div`
  cursor: pointer;
  color: rgba(153,153,153,1);
  border-radius:10px;
  &:hover {
    color: rgba(240,185,11,1);
     }
`;

const GlobalTipStyle = createGlobalStyle`
  .bnc-tooltip-arrow{
    border-top-color: ${({ theme }) => `${theme.balanceTooltipBg} !important`};
    border-bottom-color: ${({ theme }) => `${theme.balanceTooltipBg} !important`};
  }
  .bnc-tooltip-inner {
     background: ${({ theme }) => theme.balanceTooltipBg};
     color: ${({ theme }) => theme.fontColor};
  }
`;

export type State = {
  pro: boolean,
}

export type Props = {
  assetName: string,
  balance: string,
  isExistMarginAccount: boolean,
  isMarginPair: boolean,
  marginStatus: boolean,
  side: string,
  marginAssetModeSwitching: boolean,
  marginBorrow_BUY: boolean,
  marginBorrow_SELL: boolean,
  setMarginModeTrue: Function,
  setMarginModeFalse: Function,
  setMarginAssetModeStart: Function;
  setMarginAssetModeSell: Function,
  setMarginAssetModeEnd: Function;
  setMarginAccountMaxBorrowable: Function,
  pair: any,
  i18n: Object,
  router: Object,
  isLoggedIn: boolean,
  theme: Object,
  orderType?: string,
};

export default
@withI18n
@withRouter
@withTheme
@connect(({
  isLoggedIn,
  isMarginPair,
  marginStatus,
  marginBorrow_BUY,
  marginBorrow_SELL,
  userInfo: { isExistMarginAccount },
}) => ({
  isLoggedIn,
  isMarginPair,
  marginStatus,
  marginBorrow_BUY,
  marginBorrow_SELL,
  isExistMarginAccount,
}), {
  setMarginModeTrue: setMarginModeTrueAction,
  setMarginModeFalse: setMarginModeFalseAction,
  setMarginAccountMaxBorrowable: setMarginAccountMaxBorrowableAction,
  fetchMaxBorrowAmout: fetchMaxBorrowAmount,
})
class Balance extends React.PureComponent<Props, State> {
  state={
    pro: false,
  }

  static defaultProps = {
    router: { pathname: '' },
    theme: {},
    isExistMarginAccount: false,
  }

  static getDerivedStateFromProps({
    router: { pathname },
  }: Props) {
    const pro = pathname === '/trade-pro';
    return { pro };
  }

  render() {
    const {
      balance,
      assetName,
      isMarginPair,
      marginStatus,
      marginBorrow_BUY,
      marginBorrow_SELL,
      orderType,
      side,
      i18n,
      theme,
      isLoggedIn,
    } = this.props;
    const { pro } = this.state;
    const mode = side === 'BUY' ? marginBorrow_BUY : marginBorrow_SELL;
    const ocoType = orderType === 'oco';
    const isMargin = marginStatus && isMarginPair;
    return (
      <BalanceBox>
        <GlobalTipStyle />
        {isLoggedIn && isMargin && !ocoType ?
          <React.Fragment>
            <Icon type={mode ? 'yinhangqia' : 'balance1'} size={mode ? 18 : 16} color={theme.fontColor} style={{ lineHeight: '18px' }} />
            {pro && balance.length > 8 ?
              <Tooltip
                placement="top"
                trigger={['hover']}
                overlay={
                  <TipContent>
                    {balance} {assetName}
                  </TipContent>
                }
              >
                <Content>&nbsp;{balance.slice(0, 9).concat('...')} {assetName} </Content>
              </Tooltip>
              :
              <Content> &nbsp;{balance} {assetName} </Content>
            }
            {mode ?
              <Tooltip
                placement="bottom"
                trigger={['hover']}
                overlay={
                  <TipContent>{side === 'BUY' ? getLabel('exchange-margin-assetModeBuyTip', i18n)
                    : getLabel('exchange-margin-assetModeSellTip', i18n)}
                  </TipContent>
              }
              >
                <IconTipWrapper>
                  <Icon type="prompt" size={12} color={theme.fontColor} />
                </IconTipWrapper>
              </Tooltip>
              : null
            }
          </React.Fragment>
          :
          <React.Fragment>
            <Icon type="balance1" size={18} color={theme.fontColor} />
            &nbsp;{balance} {assetName}
          </React.Fragment>
        }
      </BalanceBox>
    );
  }
}
